// import React from "react";

// const DataTable = ({ columns, data, page, perPage, setPage }) => {
//   const start = (page - 1) * perPage;
//   const paginated = data.slice(start, start + perPage);

//   return (
//     <div className="overflow-x-auto">
//       <table className="min-w-full border border-gray-300 rounded-lg text-sm">
//         <thead className="bg-blue-100 text-gray-700">
//           <tr>
//             {columns.map((col, i) => (
//               <th key={i} className="p-3 border text-left">
//                 {col.header}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {paginated.length > 0 ? (
//             paginated.map((row, i) => (
//               <tr key={i} className="hover:bg-gray-50 text-center">
//                 {columns.map((col, j) => (
//                   <td key={j} className="p-3 border">
//                     {col.render ? col.render(row) : row[col.accessor]}
//                   </td>
//                 ))}
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td
//                 colSpan={columns.length}
//                 className="text-center p-4 text-gray-500"
//               >
//                 No data found
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>

//       {/* Pagination Controls */}
//       <div className="flex justify-center items-center gap-3 mt-3">
//         <button
//           onClick={() => setPage((p) => Math.max(p - 1, 1))}
//           disabled={page === 1}
//           className="bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded disabled:opacity-40"
//         >
//           Prev
//         </button>
//         <span>
//           Page {page} of {Math.ceil(data.length / perPage) || 1}
//         </span>
//         <button
//           onClick={() =>
//             setPage((p) =>
//               start + perPage >= data.length ? p : p + 1
//             )
//           }
//           disabled={start + perPage >= data.length}
//           className="bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded disabled:opacity-40"
//         >
//           Next
//         </button>
//       </div>
// import React from "react";

// const DataTable = ({ columns, data, page, perPage, setPage }) => {
//   const start = (page - 1) * perPage;
//   const paginated = data.slice(start, start + perPage);

//   return (
//     <div className="overflow-x-auto">
//       <table className="min-w-full border border-gray-300 rounded-lg text-sm">
//         <thead className="bg-blue-100 text-gray-700">
//           <tr>
//             {columns.map((col, i) => (
//               <th key={i} className="p-3 border text-left">
//                 {col.header}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {paginated.length > 0 ? (
//             paginated.map((row, i) => (
//               <tr key={i} className="hover:bg-gray-50 text-center">
//                 {columns.map((col, j) => (
//                   <td key={j} className="p-3 border">
//                     {col.render ? col.render(row) : row[col.accessor]}
//                   </td>
//                 ))}
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td
//                 colSpan={columns.length}
//                 className="text-center p-4 text-gray-500"
//               >
//                 No data found
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>

//       {/* Pagination Controls */}
//       <div className="flex justify-center items-center gap-3 mt-3">
//         <button
//           onClick={() => setPage((p) => Math.max(p - 1, 1))}
//           disabled={page === 1}
//           className="bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded disabled:opacity-40"
//         >
//           Prev
//         </button>
//         <span>
//           Page {page} of {Math.ceil(data.length / perPage) || 1}
//         </span>
//         <button
//           onClick={() =>
//             setPage((p) =>
//               start + perPage >= data.length ? p : p + 1
//             )
//           }
//           disabled={start + perPage >= data.length}
//           className="bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded disabled:opacity-40"
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default DataTable;
// src/components/common/DataTable.jsx
import React from "react";

const getPageNumbers = (currentPage, totalPages) => {
  const pages = [];
  const maxButtons = 5;
  if (totalPages <= maxButtons) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    pages.push(1);
    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);
    if (currentPage <= 2) {
      end = 3;
    } else if (currentPage >= totalPages - 1) {
      start = totalPages - 2;
    }
    if (start > 2) {
      pages.push("...");
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    if (end < totalPages - 1) {
      pages.push("...");
    }
    pages.push(totalPages);
  }
  return pages;
};

const DataTable = ({
  columns,
  data = [],
  page,
  totalPages = 1,
  setPage,
  limit,
  setLimit,
  sortConfig = { key: null, direction: "asc" },
  onSort = null,
}) => {
  const safePage = Number(page || 1);
  const safeTotalPages = Math.max(Number(totalPages || 1), 1);
  const pageRecords = Array.isArray(data) ? data.length : 0;

  const handleHeaderClick = (col) => {
    if (!onSort) return;
    const sortKey = col.sortKey || col.accessor;
    if (!sortKey) return;

    let direction = "asc";
    if (sortConfig.key === sortKey && sortConfig.direction === "asc") {
      direction = "desc";
    }
    onSort(sortKey, direction);
  };

  return (
    <section className="admin-data-table">
      <header className="admin-data-table-head">
        <div>
          <p className="admin-data-table-eyebrow">Records View</p>
          <h3 className="admin-data-table-title">{pageRecords} entries in current page</h3>
        </div>
        <div className="flex items-center gap-3">
          {setLimit && (
            <div className="flex items-center gap-1.5 text-xs font-semibold text-slate-800">
              <span className="text-slate-500 font-medium">Show</span>
              <select
                value={limit}
                onChange={(e) => setLimit(Number(e.target.value))}
                className="border border-slate-300 rounded px-1.5 py-0.5 bg-white focus:outline-none focus:ring-1 focus:ring-blue-500 cursor-pointer"
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <span className="text-slate-500 font-medium">per page</span>
            </div>
          )}
          <span className="admin-data-table-page-chip">
            Page {safePage} / {safeTotalPages}
          </span>
        </div>
      </header>

      <div className="admin-data-table-scroll">
        <table className="min-w-full border-collapse text-xs sm:text-sm">
          <thead>
            <tr>
              {columns.map((col, idx) => {
                const sortKey = col.sortKey || col.accessor;
                const isSorted = sortConfig && sortConfig.key === sortKey;
                const isSortable = !!onSort && !!sortKey;

                return (
                  <th
                    key={idx}
                    onClick={() => isSortable && handleHeaderClick(col)}
                    className={`px-2 sm:px-4 py-2 text-left text-xs sm:text-sm font-semibold whitespace-nowrap select-none ${
                      isSortable ? "cursor-pointer hover:bg-slate-200 transition" : ""
                    }`}
                  >
                    <div className="flex items-center gap-1">
                      <span>{col.header}</span>
                      {isSortable && (
                        <span className="text-[10px] text-slate-400">
                          {isSorted
                            ? sortConfig.direction === "asc"
                              ? "▲"
                              : "▼"
                            : "↕"}
                        </span>
                      )}
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan={columns.length}
                  className="text-center py-7 text-gray-500"
                >
                  No records found
                </td>
              </tr>
            ) : (
              data.map((row, rowIdx) => (
                <tr key={rowIdx}>
                  {columns.map((col, colIdx) => (
                    <td key={colIdx} className="px-2 sm:px-4 py-1.5 text-xs sm:text-sm align-middle">
                      {col.render ? col.render(row, rowIdx) : row[col.accessor] ?? "-"}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {safeTotalPages > 1 && (
        <div className="admin-data-table-pagination">
          <button
            disabled={safePage === 1}
            onClick={() => setPage(safePage - 1)}
            className="admin-data-table-page-btn"
          >
            ◀ Prev
          </button>

          {getPageNumbers(safePage, safeTotalPages).map((pageNum, idx) => {
            if (pageNum === "...") {
              return (
                <span key={`ell-${idx}`} className="px-2 text-slate-500 font-medium select-none">
                  ...
                </span>
              );
            }
            return (
              <button
                key={pageNum}
                onClick={() => setPage(pageNum)}
                className={`admin-data-table-page-btn ${safePage === pageNum ? "is-active" : ""}`}
              >
                {pageNum}
              </button>
            );
          })}

          <button
            disabled={safePage === safeTotalPages}
            onClick={() => setPage(safePage + 1)}
            className="admin-data-table-page-btn"
          >
            Next ▶
          </button>
        </div>
      )}
    </section>
  );
};

export default DataTable;
